import {
	Button,
	createMuiTheme,
	MuiThemeProvider,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteProductFamily,
	getProductFamilyById,
	postProductFamily,
	updateProductFamily,
} from "../../../../api/productFamily";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyFamily() {
	return {
		descripcion: null,
		referencia: null,
	};
}

export default function EditProductFamiliesPage() {
	const [family, setFamily] = useState(getEmptyFamily());

	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

	const familyId = useParams().id;
	const history = useHistory();
	const location = useLocation();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const handleBack = () => {
		const prevTablePage = location.state?.page;

		history.push(
			`/familias-productos${
				prevTablePage ? "?page=" + prevTablePage : ""
			}`
		);
	};

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!familyId) {
			disableLoadingData();
			return;
		}
		getProductFamilyById(familyId, loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setFamily(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se ha podido obtener la familia.",
				});
				handleBack();
			});
	}, [familyId, disableLoadingData, history]);

	function saveFamily() {
		if (!familyId) {
			postProductFamily(family, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "¡Guardada!",
							customMessage: "Familia guardada con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se ha podido guardar la familia.",
					});
				});
		} else {
			updateProductFamily(familyId, family, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 204) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage: "Cambios guardados con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se han podido guardar los cambios.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setFamily({ ...family, [element]: event.target.value });
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Familia de producto">
						<CardHeaderToolbar>
							<Button
								onClick={() => saveFamily()}
								variant="outlined"
								color="primary"
								style={{
									marginRight: familyId ? "20px" : "",
								}}
							>
								Guardar familia
							</Button>
							{familyId && (
								<>
									<MuiThemeProvider theme={theme}>
										<Button
											className="py-2"
											onClick={() =>
												setOpenConfirmDialog(true)
											}
											variant="outlined"
											color="secondary"
										>
											Eliminar familia
										</Button>
									</MuiThemeProvider>
								</>
							)}
						</CardHeaderToolbar>
					</CardHeader>
					<CardBody>
						<TextField
							id={`descripcion`}
							label="Descripción"
							value={family.descripcion}
							onChange={handleChange("descripcion")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<TextField
							id={`referencia`}
							label="Referencia"
							value={family.referencia}
							onChange={handleChange("referencia")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
						/>
					</CardBody>
				</Card>
				<Button
					onClick={handleBack}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Atrás
				</Button>
				<Button
					onClick={() => saveFamily()}
					variant="outlined"
					color="primary"
					style={{ marginRight: familyId ? "20px" : "" }}
				>
					Guardar familia
				</Button>
				{familyId && (
					<>
						<MuiThemeProvider theme={theme}>
							<Button
								className="py-2"
								onClick={() => setOpenConfirmDialog(true)}
								variant="outlined"
								color="secondary"
							>
								Eliminar familia
							</Button>
						</MuiThemeProvider>

						<ConfirmDialog
							title={
								"¿Estás seguro de que quieres eliminar esta familia?"
							}
							open={openConfirmDialog}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								deleteProductFamily(
									familyId,
									loggedUser?.accessToken
								)
									.then((res) => {
										if (
											res.status === 204 ||
											res.status === 200
										) {
											alertSuccess({
												title: "¡Eliminada!",
												customMessage:
													"Familia eliminada con éxito",
											});
											handleBack();
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage:
												"No se ha podido eliminar la familia.",
										});
									});
							}}
						/>
					</>
				)}
			</>
		);
}
